
export default {
  name: 'MobileTableCityPrices',
  props: {
    head: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    rowHover: {
      type: Boolean,
      default: false,
    }
  },
  emits: [
    'clickRows',
  ],
  data() {
    return {
      openedList: []
    }
  },
  methods: {
    openList: function (item) {
      const isIncludesInList = this.openedList.includes(item);
      if (!isIncludesInList) {
        this.openedList.push(item)
      } else {
        this.openedList = this.openedList.filter(i => i !== item);
      }
    },
    checkIsOpen: function (item) {
      return this.openedList.includes(item);
    },
    clickRows: function (row) {
      if (!this.rowHover) {
        return;
      }
      this.$emit("clickRows", row);
    },
  }
}
